var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"satisfaction-title"},[_vm._v(_vm._s(_vm.$t('satisfaction.title')))]),_vm._v(" "),_c('div',{staticClass:"satisfaction-top"},[_c('satisfaction-search')],1),_vm._v(" "),_c('table-satisfaction')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66297843","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cases/satisfaction/Satisfaction.vue
// module id = 24mN
// module chunks = 0